import classNames from "classnames";
import Image from "next/image";
import Link from "@/components/UI/Link/Link";
import { PublicPageZip, getPageUrl } from "@/utils/page";
import { publicConfig } from "@/PublicConfig";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";

interface Section24Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

type RelatedPageItem = {};

const Section24 = ({ className, page, section, ...props }: Section24Props) => null;

export default Section24;
